import { Skeleton } from "antd";
import type { AvatarProps } from "antd/es/skeleton/Avatar";
import type { FC, PropsWithChildren } from "react";

export interface IotSkeletonAvatarProps extends PropsWithChildren<AvatarProps> {
    loading?: boolean;
}

export const IotSkeletonAvatar: FC<IotSkeletonAvatarProps> = (props) => {
    const { children, active, loading = true, ...restProps } = props;

    /* This overrides the default behaviour of Ant Design */
    /* they always render the children, we will not */
    return loading ? (
        <Skeleton.Avatar
            {...restProps}
            active={Boolean(active)}
        />
    ) : (
        children
    );
};
